module.exports = __webpack_public_path__ + "assets/img/1.697c5193.jpg";